import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class DateTransformInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          const body = this.convertDates(event.body);
          return event.clone({ body });
        }
        return event;
      }),
    );
  }

  private convertDates(obj: any): any {
    if (!obj || typeof obj !== 'object') {
      return obj;
    }

    for (const key of Object.keys(obj)) {
      const value = obj[key];
      // Detectar cadenas de fecha en formato ISO y convertirlas a Date
      if (typeof value === 'string' && this.isIsoDate(value)) {
        obj[key] = new Date(value);
      } else if (typeof value === 'object') {
        this.convertDates(value); // Recursivo para objetos anidados
      }
    }
    return obj;
  }

  private isIsoDate(value: string): boolean {
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/.test(value);
  }
}
